import { EStatus, ENotificationType /* INIT_NOTIFICATION */ } from '@pes-ui/utils/lib/constants';

// TODO: add a proper INIT_NOTIFICATION constant
const INIT_NOTIFICATION = 'initNotification';
class Notificator {
  constructor(labels, appMountPoint, uiStore) {
    this.appMountPoint = appMountPoint;
    this.labels = labels;
    this.uiStore = uiStore;
    this.buttonText = this.labels.comparatorButtonMessage;
  }

  show(content, buttonText = '') {
    const initNotificationCustomEvent = new CustomEvent(INIT_NOTIFICATION, {
      bubbles: true,
      detail: {
        content,
        status: EStatus.WARNING,
        type: ENotificationType.WITH_HTML,
        productsList: [],
        buttonText,
      },
    });

    this.appMountPoint.dispatchEvent(initNotificationCustomEvent);
  }

  showProductRemoved() {
    this.show(this.labels.removeFromMyFavoritesMsg);
  }

  showCompareProductAdded() {
    const addedToCompare = this.labels.comparatorAddedMessage;
    this.show(addedToCompare, this.buttonText);
  }

  showCompareProductRemoved() {
    const removedCompare = this.labels.comparatorRemoveMessage;
    this.show(removedCompare);
  }

  showMaxProductsAdded() {
    const maxProducts = this.labels.comparatorFullMessage;    
    this.show(maxProducts, this.buttonText);
  }

  showProductAdded() {
    this.show(this.labels.addToMyFavoritesMsg);
  }
}

export { Notificator };
